import { render, staticRenderFns } from "./CompanyEmailModal.vue?vue&type=template&id=f51f2bd8&scoped=true&"
import script from "./CompanyEmailModal.vue?vue&type=script&lang=js&"
export * from "./CompanyEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51f2bd8",
  null
  
)

export default component.exports